
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("di07k"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("di07k", function(module, exports) {

let $9acd0c12477e267e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9acd0c12477e267e$var$load("h3ABO"),
    $9acd0c12477e267e$var$load("5W6YV"),
    $9acd0c12477e267e$var$load("9hYRW"),
    $9acd0c12477e267e$var$load("kpm7S"),
    $9acd0c12477e267e$var$load("5wC2D"),
    $9acd0c12477e267e$var$load("2YffH"),
    $9acd0c12477e267e$var$load("g7ggm"),
    $9acd0c12477e267e$var$load("6mHrv"),
    $9acd0c12477e267e$var$load("awWN9"),
    $9acd0c12477e267e$var$load("9CYct"),
    $9acd0c12477e267e$var$load("7OghF"),
    $9acd0c12477e267e$var$load("7H5as"),
    $9acd0c12477e267e$var$load("hZtKG"),
    $9acd0c12477e267e$var$load("dkqvW"),
    $9acd0c12477e267e$var$load("lVO3w"),
    $9acd0c12477e267e$var$load("hyzoX"),
    $9acd0c12477e267e$var$load("h9Ed7"),
    $9acd0c12477e267e$var$load("eBRUf"),
    $9acd0c12477e267e$var$load("ggdmt"),
    $9acd0c12477e267e$var$load("kbRvk"),
    $9acd0c12477e267e$var$load("tKhaz"),
    $9acd0c12477e267e$var$load("7gHIc"),
    $9acd0c12477e267e$var$load("k3jER"),
    $9acd0c12477e267e$var$load("8YSo7"),
    $9acd0c12477e267e$var$load("ef2hX"),
    $9acd0c12477e267e$var$load("aGzPe"),
    $9acd0c12477e267e$var$load("9XYQ9"),
    $9acd0c12477e267e$var$load("50ame"),
    $9acd0c12477e267e$var$load("7do1E"),
    $9acd0c12477e267e$var$load("77dkW"),
    $9acd0c12477e267e$var$load("1MlIV"),
    $9acd0c12477e267e$var$load("6iz6l"),
    $9acd0c12477e267e$var$load("4SCW2"),
    $9acd0c12477e267e$var$load("jYV57"),
    $9acd0c12477e267e$var$load("76qVV"),
    $9acd0c12477e267e$var$load("hv4mn"),
    $9acd0c12477e267e$var$load("Wowvf"),
    $9acd0c12477e267e$var$load("dek7I"),
    $9acd0c12477e267e$var$load("3SmkN"),
    $9acd0c12477e267e$var$load("dYtBN"),
    $9acd0c12477e267e$var$load("kNV5Y"),
    $9acd0c12477e267e$var$load("6wr18"),
    $9acd0c12477e267e$var$load("kjZZD"),
    $9acd0c12477e267e$var$load("99Ppz"),
    $9acd0c12477e267e$var$load("5v2fx"),
    $9acd0c12477e267e$var$load("k0uQQ"),
    $9acd0c12477e267e$var$load("37ldp"),
    $9acd0c12477e267e$var$load("ffEVr"),
    $9acd0c12477e267e$var$load("9AXkC"),
    $9acd0c12477e267e$var$load("28arV"),
    $9acd0c12477e267e$var$load("hhss7"),
    $9acd0c12477e267e$var$load("lkwGP"),
    $9acd0c12477e267e$var$load("fGPXi"),
    $9acd0c12477e267e$var$load("dP7ao"),
    $9acd0c12477e267e$var$load("hogcU"),
    $9acd0c12477e267e$var$load("juJM0"),
    $9acd0c12477e267e$var$load("5P04f"),
    $9acd0c12477e267e$var$load("7EorR"),
    $9acd0c12477e267e$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.32216c65.js.map
